import { KycProcessType, type KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

export function isKycExpired(kycInfo?: KycResponse | null): boolean {
  const processType = kycInfo?.activeProcess?.type;
  return processType === KycProcessType.re_kyc || processType === KycProcessType.poi_renewal;
}
